<template>
  <nav-bar :menuItems="menuItems" :portalButton="true" />
</template>
<script>
export default {
	name: "NavigationBarNis",
	data: () => ({
		menuItems: [
			{ title: "Survey", link: "/nis", match: ["/nis/submissions"] },
			{ title: "NIS Score", link: "/nis/score", match: ["/nis/score"] },
		],
		sidebar: false
	})
}
</script>
